/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hour: NonNullable<unknown>, min: NonNullable<unknown> }} Event_State_Start_Time_H_MInputs */

const en_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starts in ${i?.hour}h ${i?.min}m`)
};

const ar_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يبدأ بعد ${i?.hour} س و${i?.min} د`)
};

const de_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Startet in ${i?.hour}h ${i?.min}m`)
};

const es_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comienza en ${i?.hour}h ${i?.min}m`)
};

const fr_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commence dans ${i?.hour}h ${i?.min}m`)
};

const it_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia tra ${i?.hour}h ${i?.min}m`)
};

const ja_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour}時間${i?.min}分後に開始`)
};

const ko_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour}시간 ${i?.min}분 후 시작`)
};

const pt_br_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começa em ${i?.hour}h ${i?.min}m`)
};

const ru_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начнется через ${i?.hour}ч ${i?.min}м`)
};

const th_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มในอีก ${i?.hour} ชม. ${i?.min} นาที`)
};

const tr_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} sa ${i?.min} dk sonra başlıyor`)
};

const zh_cn_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} 时 ${i?.min} 分后开始`)
};

const zh_tw_event_state_start_time_h_m = /** @type {(inputs: Event_State_Start_Time_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} 時 ${i?.min} 分後開始`)
};

/**
* | output |
* | --- |
* | "Starts in {hour}h {min}m" |
*
* @param {Event_State_Start_Time_H_MInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_state_start_time_h_m = /** @type {((inputs: Event_State_Start_Time_H_MInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_State_Start_Time_H_MInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_state_start_time_h_m(inputs)
	if (locale === "ar") return ar_event_state_start_time_h_m(inputs)
	if (locale === "de") return de_event_state_start_time_h_m(inputs)
	if (locale === "es") return es_event_state_start_time_h_m(inputs)
	if (locale === "fr") return fr_event_state_start_time_h_m(inputs)
	if (locale === "it") return it_event_state_start_time_h_m(inputs)
	if (locale === "ja") return ja_event_state_start_time_h_m(inputs)
	if (locale === "ko") return ko_event_state_start_time_h_m(inputs)
	if (locale === "pt_br") return pt_br_event_state_start_time_h_m(inputs)
	if (locale === "ru") return ru_event_state_start_time_h_m(inputs)
	if (locale === "th") return th_event_state_start_time_h_m(inputs)
	if (locale === "tr") return tr_event_state_start_time_h_m(inputs)
	if (locale === "zh_cn") return zh_cn_event_state_start_time_h_m(inputs)
	return zh_tw_event_state_start_time_h_m(inputs)
});